import decodeToken from './decodeToken';

export function getTokenType(token) {
	const { partner, type, exp } = (token && decodeToken(token)) || {};
	switch (true) {
		case partner === 'ConnectOurKids':
			return 'connect';
		case ['auditoraccess'].includes(type):
			return type;
		case !!exp:
			return 'readonly';
		default:
			return 'default';
	}
}

export function getTokenUser(token) {
	if (!token) return {};
	const decodedToken = decodeToken(token);
	return normalizeTokenUser(decodedToken);
}

export function normalizeTokenUser(decodedToken = {}) {
	const normalizedUser = { ...decodedToken, tos: false };
	if (decodedToken.type === 'case-manager' && decodedToken.userId) {
		normalizedUser.id = decodedToken.userId;
	}
	return normalizedUser;
}
